import type Parse from 'parse';

import { DeviceType } from '@telespot/domain';

import { ParseMapper } from '../../parse.mapper';
import { ObjectTopology, SoftDeletableTopology } from '../../parse.topology';

export enum DeviceTypeTopology {
  TABLE = 'DeviceType',
  NAME = 'name',
  VERSION = 'version',
}

export class ParseDeviceTypeMapper extends ParseMapper {

  public toDomain(object: Parse.Object): DeviceType {
    return new DeviceType({
      id: object.id,
      name: object.get(DeviceTypeTopology.NAME),
      createdAt: object.get(ObjectTopology.CREATED_AT),
      updatedAt: object.get(ObjectTopology.UPDATED_AT),
      deletedAt: object.get(SoftDeletableTopology.DELETED_AT),
      version: object.get(DeviceTypeTopology.VERSION),
    });
  }

  public fromDomain(domain: DeviceType): Parse.Object {
    const parseObject = this.parse.Object.fromJSON({
      className: DeviceTypeTopology.TABLE,
      [ObjectTopology.ID]: domain.id,
      [ObjectTopology.CREATED_AT]: domain.createdAt,
      [ObjectTopology.UPDATED_AT]: domain.updatedAt,
      [SoftDeletableTopology.DELETED_AT]: domain.deletedAt,
    });

    parseObject.set({
      [DeviceTypeTopology.NAME]: domain.name,
      [DeviceTypeTopology.VERSION]: domain.version,
    });

    return parseObject;
  }
}
